import { LIST_FAVOURITE_ERROR, LIST_FAVOURITE, ADD_FAVOURITE_ERROR, ADD_FAVOURITE_INFO } from "../types";
var FormData = require("form-data");
import { toast } from "react-toastify";
import axios from "axios";

export const handleFavouriteLish = (e) => async (dispatch) => {
    try {
        var token = localStorage.getItem("token_key");
        // console.log(token);
        var data = new FormData();

        var config = {
            method: "get",
            url: `${process.env.NEXT_PUBLIC_API_URL}/favouritelist`,
            headers: {
                'Authorization': `Bearer ${token}`,
                'Access-Control-Allow-Headers': '*',
                'Access-Control-Allow-Origin': '*'
            },
            data: data,
        };
        const res = await axios(config);

        // console.log(res);
        dispatch({
            type: LIST_FAVOURITE,
            payload: res.data,
        });
    } catch (error) {
        // console.log(error, 'error');
        dispatch({
            type: LIST_FAVOURITE_ERROR,
            payload: error,
        });
    }
};
export const updateUserInfo = (e, type) => async (dispatch) => {
    try {
        var token = localStorage.getItem("token_key");
        var data = new FormData();
        if (type == "home_owner") {
            data.append("firstname", e.first_name);
            data.append("phone", e.phone_number);
            data.append("email", e.email_address);
            data.append("lastname", e.last_name);
        } else {
            data.append("businessaddress", e.business_address);
            data.append("phone", e.phone_number);
            data.append("email", e.email);
            data.append("state", e.state);
            data.append("city", e.city);
            data.append("zip", e.zip_code);
            data.append("businessname", e.business_name);
        }

        var config = {
            method: "post",
            url: `${process.env.NEXT_PUBLIC_API_URL}/favouriteadd`,
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            data: data,
        };
        const res = await axios(config);

        dispatch({
            type: ADD_FAVOURITE_INFO,
            payload: res.data.res,
        });

        // console.log(res);

        if (res.data.success) {
            toast.success(`Profil updated successfully`, {
                onClose: () => dispatch(handleUserInfo()),
            });
        }
    } catch (error) {
        dispatch({
            type: ADD_FAVOURITE_ERROR,
            payload: error,
        });
    }
};
